<form [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" *ngIf="show.form && validation"
  (ngSubmit)="saveOrUpdate(dialogBoxSalesNetwork)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.code.nullable}">{{ validation.code.keyName
          }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="code" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm"
          [validation]="validation.code"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.name.nullable}">{{ validation.name.keyName
          }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="name" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm"
          [validation]="validation.name"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.description.nullable}">{{
          validation.description.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="description" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm"
          [validation]="validation.description"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.logo_name.nullable}">{{
          validation.logo_name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="logo_name" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm"
          [validation]="validation.logo_name"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.logo.nullable}">{{ validation.logo.keyName
          }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="logo" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm"
          [validation]="validation.logo"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.source_system_id.nullable}">{{
          validation.source_system_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown [style]="{'width':'100%'}" formControlName="source_system_id"
          [options]="sourceSystemList"></p-dropdown>
        <app-validation-msg [arrayValidators]="validators.integerNotNegative" [(fireInvalidSubmit)]="invalidSubmit"
          [(form)]="addEditForm" [validation]="validation.source_system_id"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.company_host_code}">{{
          validation.company_host_code.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="company_host_code" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm"
          [validation]="validation.company_host_code"></app-validation-msg>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane text-center ui-helper-clearfix">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
        label="{{dialogBoxSalesNetwork.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'salesNetworkList.saleNetwork' |translate }}"></button>
    </div>
  </p-footer>
</form>


// WEBPACK FOOTER //
// ./src/app/views/administration/sales-network/salesNetworkForm.component.html